import { useLocation } from 'react-router-dom';

import { ClusterSettings, Job } from '@typings';
import { useContextSearchParams } from '@hooks';
import { cn, path } from '@utils';
import { settingsTabs } from '@content';

import { Link } from '@components';

type Props = {
  instanceId: string;
};

export const PlatformAppsInstanceTabs = ({ instanceId }: Props) => {
  const { pathname } = useLocation();
  const { contextSearchParams } = useContextSearchParams();

  const getPath = (tab: Job.Tab | string) => {
    const formattedTab = tab === '/' ? undefined : (tab as Job.Tab);

    return `${path.appsInstance(
      instanceId,
      formattedTab,
    )}?${contextSearchParams}`;
  };

  const makeTab = ({ path, title }: ClusterSettings.Tab) => {
    const tab = path as string;
    const isActive = pathname.includes(`/${tab}`);

    return (
      <Link
        theme
        key={tab}
        className={cn(
          'block border-b-2 border-transparent pb-4 pt-2 text-h6 capitalize text-neural-04 transition-colors hover:text-rebecca',
          { 'border-primary text-rebecca': isActive },
        )}
        to={getPath(tab)}
      >
        {title}
      </Link>
    );
  };

  return (
    <header className="flex gap-10 border-b border-neural-01 px-10 pt-6">
      {settingsTabs.app.map(makeTab)}
    </header>
  );
};
